import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import userActions from 'actions/users'
import tenantActions from 'actions/tenants'
import ticketCategoryActions from 'actions/ticketCategories'
import Component from 'components/Tickets/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  users: selectors.users.selectOptions(state),
  tenants: selectors.tenants.selectOptions(state),
  ticketCategories: selectors.ticketCategories.selectOptions(state),
})

const mapDispatchToProps = (dispatch, props) => ({
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
  getTenants: (params) => dispatch(tenantActions.getOptions(params)),
  getTicketCategories: (params) => dispatch(ticketCategoryActions.getOptions(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
